export class TranslationDto<T = string> {
  en: T
  km: T
  cn: T

  public static create(en?: any, km?: any, cn?: any) {
    const translation = new TranslationDto()

    translation.en = en || ''
    translation.km = km || ''
    translation.cn = cn || ''

    return translation
  }
}
